module.exports = __webpack_public_path__ + "img/video-icon-active.a59d2cc1.svg";